import type { DynamicThemeType, Videos } from '../../style/themes';

const getPath = (theme: DynamicThemeType, relativePath: string): string | undefined => {
  if (theme !== 'default') {
    return undefined;
  }

  const baseUrl = 'https://app.venn.twosigma.com';
  return `${baseUrl}/${relativePath}`;
};

export const getVideoTheme = (theme: DynamicThemeType): Videos => ({
  splashScreenAnimation: getPath(theme, 'splash-screen-animation.mp4'),
  factorLensVideo: getPath(theme, 'TSFL.mp4'),
  productTourVideo: getPath(theme, 'productWalkthrough.mp4'),
  aisDemoVideo: getPath(theme, 'ais_demo.mp4'),
  portfolioFilteringOnboarding: getPath(theme, 'onboarding-portfolio-filtering.mp4'),
  blockMultiselectOnboarding: getPath(theme, 'onboarding-block-multiselect.mp4'),
});
